var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"functional-button",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.editPlayer($event)}}},[_c('i',{staticClass:"far fa-code"}),_vm._v(" "),_c('span',[_vm._v("Embed code")])])}
var staticRenderFns = []

export { render, staticRenderFns }